/**
 * Check if `val` would normally cause an attribute in react to be omitted,
 * instead of set to the literal value.
 * Returns true for `false`, `null`, and `undefined`.
 */
export default function isReactFalsy(val) {
    return val == null || val === false;
}
